/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React, { useRef } from 'react';
import clsx from 'clsx';
import Popup from 'reactjs-popup';
import { ChevronDown } from '@td-client-frontend/icons';

interface Props {
  label: string;
  options: { label: string; onClick: () => void }[];
  disabled?: boolean;
  styles?: string;
  dropdownStyles?: string;
  position?: PopupPosition;
}

type PopupPosition =
  | 'top left'
  | 'top center'
  | 'top right'
  | 'right top'
  | 'right center'
  | 'right bottom'
  | 'bottom left'
  | 'bottom center'
  | 'bottom right'
  | 'left top'
  | 'left center'
  | 'left bottom'
  | 'center center';
type PopupActions = {
  open: () => void;
  close: () => void;
  toggle: () => void;
};

export const OptionsDropdown = ({
  label,
  options,
  disabled = false,
  styles = '',
  dropdownStyles = '',
  position = 'bottom left'
}: Props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<PopupActions>(null!);

  const closePopup = () => popupRef.current.close();

  return (
    <div ref={divRef}>
      <Popup
        ref={popupRef}
        trigger={
          <div
            className={clsx(
              'inline-flex items-center px-2 bg-white cursor-pointer',
              styles,
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            <span className='text-base truncate'>{label}</span>
            <ChevronDown aria-hidden className='transform block h-3 w-3 ml-1 fill-current' />
          </div>
        }
        disabled={disabled}
        position={position}
        on='click'
        closeOnDocumentClick
        arrow={false}
        contentStyle={{ zIndex: 30 }}
      >
        <div
          className={clsx('bg-white border rounded', dropdownStyles)}
          style={{ width: `${divRef.current?.clientWidth}px` }}
        >
          {options.map(({ label: name, onClick }: { label: string; onClick: () => void }, buttonIndex) => {
            return (
              <div
                key={name}
                className='hover:bg-gray-10 font-normal text-base cursor-pointer'
                onClick={() => {
                  onClick();
                  closePopup();
                }}
                aria-hidden='true'
              >
                <div
                  className={clsx(
                    'mx-1 p-2 flex flex-wrap border-b-1 border-gray-20',
                    name === label && 'border-b-2 border-blue-80'
                  )}
                >
                  {name}
                </div>
              </div>
            );
          })}
        </div>
      </Popup>
    </div>
  );
};
